<template>
  <form @submit.prevent="create">
    <modal-card title="Add Feed" class="" style="margin: 0;width: 75vw; height: 100vh;">
      <div class="columns mt-1">
        <div class="column is-6">
          <b-field label="Language">
            <b-select v-model="form.locale">
              <option :value="key" v-for="(label, key) in languages" :key="key">
                {{ label }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Title">
            <b-input type="text" v-model="form.title" placeholder="Feed Title"></b-input>
          </b-field>
          <b-field label="Description">
            <textarea class="textarea" rows="10" style="resize: none;" v-model="form.description"
                      placeholder="Feed Description"></textarea>
          </b-field>
          <div class="subscription">
          </div>
          <p class="title is-5">Images</p>
          <div class="columns">
            <div class="column is-6">
              <div class="mb-4">
                <upload-file
                  ref="uploadFile"
                  :endpoint="kytebaseMediaUploadUrl"
                  :additional="{ collection: 'images' }"
                  @uploaded="onBackgroundUploaded"
                  auto-reset
                >
                  <template slot-scope="{progress}">
                    <div v-if="progress && ! progress.isComplete()">
                      Uploading {{ progress.percent() }}%
                    </div>
                    <image-picker
                      v-else
                      @picked="file => $refs.uploadFile.upload(file)"
                      croppable
                      :croppie="{
                    aspectRatio: 1,
                    viewMode: 3,
                    autoCropArea: 1
                  }"
                    >
                      <a slot="trigger">
                        <button
                          type="button"
                          slot="trigger"
                          class="button is-outlined is-primary is-small"
                        >Upload Background
                        </button>
                      </a>
                    </image-picker>
                  </template>
                </upload-file>
              </div>
              <img v-if="form.background_url" :src="form.background_url"/>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="Start Date">
                <datetimepicker v-model="form.starts_at"></datetimepicker>
              </b-field>
            </div>

            <div class="column">
              <b-field label="End Date">
                <datetimepicker v-model="form.ends_at"></datetimepicker>
              </b-field>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="card p-5" style="height: 650px; overflow: auto">
            <section>
              <b-tabs v-model="activeTab">

                <b-tab-item label="Texts">
                  <div id="htmlFile" v-on:mouseup="onSelect">
                  </div>
                </b-tab-item>
              </b-tabs>
            </section>
          </div>
        </div>
      </div>
      <div slot="foot">
        <button type="button" class="button" @click="$parent.close()">
          Close
        </button>
        <button class="button is-primary">
          Add Feed
        </button>
      </div>
    </modal-card>
  </form>
</template>
<script>
import {getActiveLanguages} from "../../../../../../data/languages";
import ImagePicker from "../../../../../../components/ImagePicker";
import UploadFile from "../../../../../../components/UploadFile";

export default {
  components: {
    ImagePicker,
    UploadFile,
  },
  props: {
    feed: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeTab: 0,
      isImageModalActive: false,
      publication: 1,
      page: this.feed.page_number,
      form: new window.Form(this.feed),
      languages: getActiveLanguages(),
      data: null,
      pictures: null,
      pictureData: new window.RemoteData(() => {
        return `/admin/api/magazine/content-images?path=${this.feed.image_path}`;
      }),
      textData: new window.RemoteData(() => {
        return `/admin/api/magazine/content-text?path=${this.feed.image_path}`;
      }),
    }
  },
  computed: {
    tags: {
      get() {
        return this.form && this.form.tags && this.form.tags.length > 0
          ? this.form.tags.split(",")
          : [];
      },

      set(value) {
        this.form.tags = value.join(",");
      }
    },
    kytebaseMediaUploadUrl() {
      return window.app.$store.getters.kytebaseMediaUploadUrl;
    }
  },
  created() {
    this.pictureData.load(() => {
      this.pictures = this.pictureData.response;
      this.form.background_path = this.pictureData.response.data[0].path;
      this.form.background_url = this.pictureData.response.data[0].url;
    });
    this.textData.load(() => {
      if (this.textData.message === null) {
        document.getElementById('htmlFile').innerHTML = this.textData.response.data.file;
        document.getElementById('htmlFile').querySelectorAll('*').forEach(element => {
          element.removeAttribute("style");
          if (element.tagName == 'IMG' || element.tagName == 'TITLE' ||
            element.tagName == 'LINK' || element.tagName == 'META' ||
            element.tagName == 'SCRIPT' || element.tagName == 'VIDEO' ||
            element.tagName == 'AUDIO') {
            element.remove();
          }
        })
      } else {
        alert(this.textData.response.data.message);
      }
    });
  },
  methods: {
    create() {
      let whenAdded = this.whenAdded;
      this.form.post("/admin/api/feeds").then(function (respose) {
        whenAdded(respose);
      });
    },
    onBackgroundUploaded({data: image}) {
      this.form.background_path = image.path;
      this.form.background_url = image.url;
    },
    onSelect() {
      if (window.getSelection().toString().length > 0) {
        this.form.description = window.getSelection().toString();
      }
    },
    whenAdded(data) {
      this.$buefy.snackbar.open({
        duration: 5000,
        message: 'New feed has been added.<br /><small>Click to edit this feed.</small>',
        type: 'is-success',
        position: 'is-top',
        actionText: 'Edit',
        queue: false,
        onAction: () => {
          this.redirectToDetailPage(data.data.id);
        }
      });
      this.$parent.close();
    },
    redirectToDetailPage(feedId) {
      window.app.$router.push(`/feeds/${feedId}/edit`);
    }
  }
};
</script>
